import React, { FC } from 'react';

import Badge from '@material-ui/core/Badge';
import { navigate } from '@reach/router';

import { IClub } from '../../../../../store/player/clubs/store';

import Button from '../../../../../components/Button';
import { defaultClubLogo } from '../../../../../assets/images';

interface IProps {
  club: IClub;
}

const ClubPickerItem: FC<IProps> = props => {
  const {
    club: { status, id, profileImage, name }
  } = props;

  const goTo = () => {
    const route = status === 'invited' ? `/club-payment/${id}` : `/club/${id}`;

    navigate(route);
  };

  return status === 'invited' ? (
    <div>
      <Badge color="primary" badgeContent="!" className="badge" onClick={goTo}>
        <Button className="club" variant="outlined" color="primary">
          <img src={profileImage ? profileImage : defaultClubLogo} alt={`${name} logo`} />
        </Button>
      </Badge>
    </div>
  ) : (
    <div>
      <Button className="club" variant="outlined" color="primary" onClick={goTo}>
        <img src={profileImage ? profileImage : defaultClubLogo} alt={`${name} logo`} />
      </Button>
    </div>
  );
};

export default ClubPickerItem;
